import { formatDistanceToNow } from 'date-fns';

export const formatDaysUntilEnd = (date: number): string =>
  date > 0 && date !== null && date !== undefined
    ? formatDistanceToNow(date)
    : '';
